/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react'

export function useClickOutside(refs, callback) {
  useEffect(() => {
    function handleClickOutside(evt) {
      const isOutsideClick = refs?.every((ref) => {
        if (!ref.current) {
          return true
        }

        return ref.current && !ref.current.contains(evt.target )
      })

      if (isOutsideClick) {
        callback(evt)
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [refs, callback])
}
